<template>
    <el-card v-bind="$attrs">
        <el-row class="card-header align-left line-height40" style="background: lightgray">
           <el-col :span="16"><h3 class="margin20 margin-none-v">{{title}}</h3></el-col>
                </el-row>
                  <div class="card-content" :style="contentStyle">
                      <cus-form
                          ref="formRef"
                          :columns="columns"
                          :data="data"
                          @confirm="handleConfirm"
                      >
                      </cus-form>
                  </div>
     </el-card>
</template>
<script>

export default {
    props: {
        title: {
            type: String
        },
        contentStyle: {
            type: Object,
            default: () => ({})
        },
        columns: {
            type: Array,
            default: () => []
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        getFormInstance() {
            return this.$refs.formRef
        },
        handleConfirm() {

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Surgery/SaftyCheck/FormCard.vue